export default "__VITE_ASSET__39448090__"